import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Company Formation in Dominica',
        link: '/company-formation-dominica',
    },
]

function CompanyFormationDominica() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Company Formation in Dominica</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Fast, Confidential & Tax-Neutral Offshore Companies
                            </h3>
                            <p className='page-paragraph'>
                                <b>Dominica</b> is one of the <b>Caribbean’s most efficient and affordable jurisdictions</b> for <b>offshore company formation</b>. Its <b>International Business Companies (IBCs)</b> are widely used for <b>asset protection, international trade, tax planning, and investment structures</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Incorporation in 1–3 Days",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Zero Tax on Foreign Income",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Full Confidentiality",
                                        icon: TiTick,
                                    },
                                ]}
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in Dominica?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tax Neutrality",
                                    paragraph: "No income, capital gains, inheritance, or withholding taxes on offshore activities",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast Incorporation",
                                    paragraph: "IBCs can be registered within 1–3 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low Costs",
                                    paragraph: "Affordable setup and annual maintenance compared to EU jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy",
                                    paragraph: "No public register of shareholders or directors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Recognition",
                                    paragraph: "Compliant with international AML/CFT standards",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Structures",
                                    paragraph: "Minimal requirements and full foreign ownership permitted",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Key Features of a Dominica IBC</h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "Minimum 1 (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Minimum 1 (can be the same as shareholder)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "No minimum paid-up capital",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Accounting",
                                    paragraph: "No requirement for audited financials (but internal records must be kept)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Meetings",
                                    paragraph: "Can be held anywhere in the world",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidentiality",
                                    paragraph: "Shareholder and director information is not publicly available",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Uses of a Dominica IBC</h3>
                        <PageList
                            items={[
                                {
                                    title: "International Trade & Consulting",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Protection & Wealth Structuring",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Holding Companies for Shares, IP, and Investments",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investment Vehicles",
                                    paragraph: "Funds, joint ventures, family offices",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Access",
                                    paragraph: "In global financial centers",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-subtitle'>Timeline: 1–3 business days (standard IBC).</p>

                        <h3 className='page-title'>Advantages of Dominica IBCs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Low Setup & Maintenance Costs",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast Incorporation",
                                    paragraph: "One of the quickest globally",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy & Asset Protection",
                                    paragraph: "Confidential structures",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexibility",
                                    paragraph: "Easy management, minimal restrictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "International Acceptance",
                                    paragraph: "Compliant with OECD/AML guidelines",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <CTA
                        title="Looking for a fast, affordable, and confidential offshore company?"
                        description=
                            "<b>Offshore Advisory</b> assists with <b>Dominica IBC incorporation</b>, <b>nominee services</b>, and <b>global bank account opening</b>."
                        buttonText="Book a Dominica Company Formation Consultation Today →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default CompanyFormationDominica

const faqData = [
    {
        question: "How long does it take to register a company in Dominica?",
        content: [
            { type: "answer", text: "1–3 business days." },
        ],
    },
    {
        question: "Can foreigners own 100% of a Dominica IBC?",
        content: [
            { type: "answer", text: "Yes, full foreign ownership is allowed." },
        ],
    },
    {
        question: "Do Dominica companies pay tax?",
        content: [
            { type: "answer", text: "No, not on foreign-sourced income." },
        ],
    },
    {
        question: "Is Dominica blacklisted internationally?",
        content: [
            { type: "answer", text: "No, Dominica complies with OECD and FATF requirements." },
        ],
    },
    {
        question: "Do I need to visit Dominica?",
        content: [
            { type: "answer", text: "No, incorporation can be done remotely." },
        ],
    },
];
